import React from 'react';
import { Save, CheckCircle } from 'lucide-react';

interface SavingIndicatorProps {
  isVisible: boolean;
}

const SavingIndicator: React.FC<SavingIndicatorProps> = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed top-4 right-4 z-50 bg-blue-600 text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2 animate-pulse">
      <Save size={16} className="animate-spin" />
      <span className="text-sm font-medium">Salvando alterações...</span>
    </div>
  );
};

export default SavingIndicator;